<div class="print-preview-container">

  <!-- Header (same structure as tutorial-header) -->
  <div class="print-preview-header">
    <div class="print-preview-title">
      <lucide-icon name="printer" [size]="20"></lucide-icon>
      <h2>Print Preview</h2>
      @if (formEntries.length > 0) {
        <span class="form-count">({{ formEntries.length }} form{{ formEntries.length !== 1 ? 's' : '' }})</span>
      }
    </div>
    <button type="button" mat-icon-button (click)="close()" matTooltip="Close" aria-label="Close">
      <lucide-icon name="x" [size]="20"></lucide-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="print-preview-body">

    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-state">
        <mat-spinner [diameter]="48"></mat-spinner>
        <p>Loading forms... {{ loadProgress }}%</p>
        <mat-progress-bar mode="determinate" [value]="loadProgress"></mat-progress-bar>
      </div>
    }

    <!-- PDF Generation Overlay -->
    @if (isGeneratingPdf) {
      <div class="generation-overlay">
        <mat-spinner [diameter]="48"></mat-spinner>
        <p>Generating PDF...</p>
      </div>
    }

    <!-- Form List Sidebar + Preview Area -->
    @if (!isLoading && formEntries.length > 0) {
      <div class="preview-layout">
        <!-- Form List -->
        <div class="form-list-panel">
          <h4>Forms to Print</h4>
          @for (entry of formEntries; track entry; let i = $index) {
            <div class="form-list-entry">
              <lucide-icon name="file-text" [size]="20"></lucide-icon>
              <span class="entry-name">{{ entry.formName }}</span>
              <button type="button" mat-icon-button (click)="removeForm(i)" matTooltip="Remove from print" aria-label="Remove from print">
                <lucide-icon name="x" [size]="20"></lucide-icon>
              </button>
            </div>
          }
        </div>
        <!-- Preview Area -->
        <div class="preview-area" #printContainer>
          @for (entry of formEntries; track entry; let i = $index) {
            <div class="print-form-entry">
              <div class="form-title-header">
                <h3>{{ entry.formName }}</h3>
              </div>
              <app-forms-form
                [cfgFormVersion]="entry.cfgFormVersion"
                [isPreviewMode]="true"
                [saveEnabled]="false"
                [actionsEnabled]="false">
              </app-forms-form>
              @if (i < formEntries.length - 1) {
                <div class="page-break-indicator">
                  <mat-divider></mat-divider>
                  <span>Page Break</span>
                  <mat-divider></mat-divider>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    <!-- Empty State -->
    @if (!isLoading && formEntries.length === 0) {
      <div class="empty-state">
        <lucide-icon name="printer" [size]="20"></lucide-icon>
        <p>No forms available to print. Selected forms may not have any versions.</p>
      </div>
    }

  </div>

  <!-- Footer -->
  <div class="print-preview-footer">
    <button type="button" mat-raised-button color="primary"
      [disabled]="isGeneratingPdf || isLoading || formEntries.length === 0"
      (click)="generatePdf()">
      <lucide-icon name="save" [size]="20"></lucide-icon>
      Save as PDF
    </button>
  </div>

</div>
